import { render, staticRenderFns } from "./policy_url.vue?vue&type=template&id=025b0d9a&scoped=true&"
import script from "./policy_url.vue?vue&type=script&lang=js&"
export * from "./policy_url.vue?vue&type=script&lang=js&"
import style0 from "./policy_url.vue?vue&type=style&index=0&id=025b0d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b0d9a",
  null
  
)

export default component.exports